'use client';

import { useTranslations } from 'next-intl';

import usePaymentFormContext from 'hooks/usePaymentFormContext';
import Input from 'ui/Input';
import SelectInput from 'ui/SelectInput';
import getCountryOptions from 'utils/getCountryOptions';
import AddressInputs from 'components/AddressInputs';

const BillingAddressForm = () => {
  const { billingAddressData, billingAddressErrors, onChangeBillingAddressData } =
    usePaymentFormContext();

  const tCheckout = useTranslations('checkout');
  const tCountries = useTranslations('countries');
  const tProfile = useTranslations('customerProfile');
  const tCommon = useTranslations('common');
  const countryOptions = getCountryOptions();
  const translatedCountryOptions = countryOptions.map((country) => {
    return { value: country.value, label: tCountries(country.label) };
  });

  return (
    <div className="sm:col-span-6 flex flex-col gap-y-5 mt-2">
      <AddressInputs
        address={billingAddressData?.address ?? ''}
        addressTwo={billingAddressData?.addressTwo ?? ''}
        addressConfig={{
          name: 'address',
          id: 'address',
          label: tCommon('address').toLocaleUpperCase(),
          placeholder: tCommon('addressPlaceholder'),
        }}
        addressTwoConfig={{
          name: 'addressTwo',
          id: 'addressTwo',
          label: tCommon('addressLineTwo').toLocaleUpperCase(),
          placeholder: tCommon('addressLineTwoPlaceholder'),
        }}
        onChange={onChangeBillingAddressData}
        errors={{
          address: billingAddressErrors.address,
        }}
        addressClassName="sm:col-span-6 flex flex-col gap-y-1"
        addressTwoClassName="sm:col-span-6 flex flex-col gap-y-1"
        labelClassName="!font-bold text-sm"
      />

      <div className="flex flex-col sm:flex-row gap-y-5 sm:gap-x-2">
        <div className="flex flex-col gap-y-1 sm:w-2/5">
          <label className="font-bold text-sm">{tCheckout('zip').toLocaleUpperCase()}</label>
          <Input
            type="text"
            name="postCode"
            id="postCode"
            dataTestId="postCode"
            placeholder={tProfile('postCodePlaceholder')}
            value={billingAddressData.postCode}
            onChange={onChangeBillingAddressData}
            errorMessage={billingAddressErrors.postCode}
            errorBorderOnly
          />
        </div>
        <div className="flex flex-col gap-y-1 sm:w-3/5">
          <label className="font-bold text-sm">{tCheckout('city').toLocaleUpperCase()}</label>
          <Input
            type="text"
            name="city"
            id="city"
            dataTestId="city"
            placeholder={tCheckout('cityPlaceholder')}
            value={billingAddressData.city}
            onChange={onChangeBillingAddressData}
            errorMessage={billingAddressErrors.city}
            errorBorderOnly
          />
        </div>
      </div>
      <div className="sm:col-span-6 flex flex-col gap-y-1">
        <label className="font-bold text-sm">{tCheckout('country').toLocaleUpperCase()}</label>
        <SelectInput
          name="country"
          id="country"
          dataTestId="country"
          value={billingAddressData.country}
          options={translatedCountryOptions}
          textSize="text-md"
          onChange={onChangeBillingAddressData}
          errorMessage={billingAddressErrors.country}
          label=""
        />
      </div>
    </div>
  );
};

export default BillingAddressForm;
